<div class="app-body animated fadeIn m-0">
  <div class="row justify-content-start m-0 py-3" style="width:100%;">
       <div class="col-lg-12 col-md-12 col-sm-12 login-new-details px-5">
           <div class="logo-org">
                <img src="/assets/img/brand/logo-high-white.png"  style="width:180px;"/>
           </div>
       </div>
   </div>
    <div class="row justify-content-start mx-0 mt-4" style="width:100%;">
      <div class="col-lg-4 col-md-6 col-sm-7 col-12 login-new-details px-5 mt-1">
            <h3 class="title">Login</h3>
            <p class="subline-text"><small>Enter your details below to continue</small></p>

            <form #loginForm="ngForm" >  <!--(ngSubmit)="login()"-->

                <!-- <p style="color: tomato;">{{errorMsg}}</p> -->
                <label class="form-group has-top-label mb-4">
                  <input class="form-control" type="text" name="loginID" [(ngModel)]="loginModel.loginid" placeholder="Login ID" required>
                  <span class="text-label">Login ID</span>
                  <i class="fa fa-regular fa-user"></i>
                </label>

                <label class="form-group has-top-label mb-4">
                  <input class="form-control" name="pw" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="loginModel.password" placeholder="Password" required>
                  <span class="text-label">Password</span>
                  <i class="fa" [ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}" aria-hidden="true" (click)="showPassword = !showPassword"></i>
                </label>

                <label class="form-group has-top-label mb-4">
                  <select class="form-control" name="clientKey" [(ngModel)]="loginModel.clientkey" required>
                    <option *ngFor="let fy of finYears" [value]="fy">{{fy}}</option>
                  </select>
                  <span class="text-label">Financial Year</span>
                  <i class="fa fa-solid fa-calendar"></i>
                </label>

                <div class="form-group mt-1">
                  <button type="submit" (click)="login()" class="btn py-3 btn-block login-btn" [disabled]="loginForm.invalid">Sign in</button>
                </div>

                <!-- <div class="form-group forgot-pass" style="display: flex;text-align:center; flex-direction: column;">
                  <a class="forgot" data-toggle="modal" >Forgot your email or password?</a>
                </div> -->

            </form>
      </div>

      <div class="col-lg-8 col-md-6 col-sm-5 col-12 right-side-nav mt-3">&nbsp;</div>

    </div>

  </div>

  